import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

// Load custom routes
import custom_build from "../../custom_build.json";
import modules_excluded from "../../modules_excluded.json";
let filtered_modules = custom_build.client.filter(
  (r) => !modules_excluded.includes(r.code_name)
);

// custom_build.client.map((r) => {
filtered_modules.map((r) => {
  var Component = require(`../../modules/${r.code_name}/frontend/${r.component}`);
  let rte = {
    path: r.path,
    name: r.name,
    component: Component.default,
    meta: r.meta,
  };
  router.addRoute(rte);
});

// custom_build.client.forEach((r) => {
// filtered_modules.forEach((r) => {
//   var Component = require(`../../modules/${r.code_name}/frontend/${r.component}`);
//   let rte = {
//     path: r.path,
//     name: r.name,
//     component: Component.default,
//     meta: r.meta,
//   };
//   router.addRoute(rte);
// });

/** JQuery */
const jQuery = require("jquery");
global.jQuery = window.$ = jQuery;

/** Bulma Swal */
import "@sweetalert2/theme-bulma/bulma.min.css";

/** Semantic UI */
// import "../semantic/dist/semantic.min.css";
import "../semantic/dist/components/calendar.min.css";
import "../semantic/dist/components/form.min.css";
import "../semantic/dist/components/dropdown.min.css";
import "../semantic/dist/components/icon.min.css";
import "../semantic/dist/components/input.min.css";
import "../semantic/dist/components/label.min.css";
import "../semantic/dist/components/popup.min.css";
import "../semantic/dist/components/table.min.css";
import "../semantic/dist/components/toast.min.css";
import "../semantic/dist/components/transition.min.css";

// import "../semantic/dist/components/ad.min.css";
// import "../semantic/dist/components/breadcrumb.min.css";
// import "../semantic/dist/components/button.min.css";
// import "../semantic/dist/components/card.min.css";
// import "../semantic/dist/components/checkbox.min.css";
// import "../semantic/dist/components/comment.min.css";
// import "../semantic/dist/components/container.min.css";
// import "../semantic/dist/components/dimmer.min.css";
// import "../semantic/dist/components/divider.min.css";
// import "../semantic/dist/components/embed.min.css";
// import "../semantic/dist/components/emoji.min.css";
// import "../semantic/dist/components/feed.min.css";
// import "../semantic/dist/components/flag.min.css";
// import "../semantic/dist/components/flyout.min.css";
// import "../semantic/dist/components/grid.min.css";
// import "../semantic/dist/components/header.min.css";
// import "../semantic/dist/components/image.min.css";
// import "../semantic/dist/components/item.min.css";
// import "../semantic/dist/components/list.min.css";
// import "../semantic/dist/components/loader.min.css";
// import "../semantic/dist/components/menu.min.css";
// import "../semantic/dist/components/message.min.css";
// import "../semantic/dist/components/modal.min.css";
// import "../semantic/dist/components/nag.min.css";
// import "../semantic/dist/components/placeholder.min.css";
// import "../semantic/dist/components/progress.min.css";
// import "../semantic/dist/components/rail.min.css";
// import "../semantic/dist/components/rating.min.css";
// import "../semantic/dist/components/reset.min.css";
// import "../semantic/dist/components/reveal.min.css";
// import "../semantic/dist/components/search.min.css";
// import "../semantic/dist/components/segment.min.css";
// import "../semantic/dist/components/shape.min.css";
// import "../semantic/dist/components/sidebar.min.css";
// import "../semantic/dist/components/site.min.css";
// import "../semantic/dist/components/slider.min.css";
// import "../semantic/dist/components/statistic.min.css";
// import "../semantic/dist/components/step.min.css";
// import "../semantic/dist/components/sticky.min.css";
// import "../semantic/dist/components/tab.min.css";
// import "../semantic/dist/components/text.min.css";

require("fomantic-ui/dist/components/form");
require("fomantic-ui/dist/components/transition");
require("fomantic-ui/dist/components/dropdown");
require("fomantic-ui/dist/components/api");
// import "../semantic/dist/semantic.min.js";

/** Font awesome */
import "font-awesome/css/font-awesome.min.css";

/** Bulma */
import "bulma/css/bulma.min.css";
// import "bulma/css/versions/bulma-no-dark-mode.min.css";

/** Localization over i18n */
import i18n from "./i18n";

/** Particles */
import Particles from "@tsparticles/vue3";
import { loadSlim } from "@tsparticles/slim";
/** Loader component */
// import LoaderPlugin from "./plugins/loader/Plugin.js";

let app = createApp(App);
app.use(i18n);
app.use(router);
app.use(Particles, {
  init: async (engine) => {
    // await loadFull(engine); // you can load the full tsParticles library from "tsparticles" if you need it
    await loadSlim(engine); // or you can load the slim version from "@tsparticles/slim" if don't need Shapes or Animations
  },
});
// app.use(LoaderPlugin);
app.mount("#app");
